import { MaybeUndef } from '../../types/system';
import { SortDirection } from './sorted-columns.reducer';

export const SORTED_COLUMNS_ACTIONS = {
  SORT: 'SORTED_COLUMNS__SORT',
};

export interface SortActionPayload {
  tableName: string;
  columnName: string;
  direction: MaybeUndef<SortDirection>;
}

export const sortColumn = (payload: SortActionPayload) => ({
  type: SORTED_COLUMNS_ACTIONS.SORT,
  payload,
});
